import React, { JSX } from 'react';
import DefaultCard from './DefaultCard';
import Styled from '../Card.styled';
import { Typography } from '../../typography/Typography.styled';
import { BlogPostCardProps } from '../types';
import useContentfulCallToAction from '../../../../hooks/useContentfulCallToAction';
import ThemeContainer from '../../ThemeContainer';
import { Theme } from '../../../../styles/themes';
import CardTag from '../CardTag';
import { Icons } from '@Levi/types/icon-types';
import CardFooterLink from '../CardFooterLink';
import useFormattedDate from '@Levi/hooks/useFormattedDate';

const BlogPostCard = ({
  title,
  image,
  description,
  callToAction,
  date,
  altlinks = [],
  theme
}: BlogPostCardProps): JSX.Element => {
  const linkProps = useContentfulCallToAction(callToAction);
  const formattedDate = useFormattedDate({ date });

  return (
    <DefaultCard title={title} image={image} theme={theme} cardLink={linkProps}>
      <Styled.CardInfoRow>
          <CardTag icon={Icons.Calendar}>{formattedDate}</CardTag>
      </Styled.CardInfoRow>
      <Typography.BodySmall>{description}</Typography.BodySmall>
      <Styled.CardFooter>{altlinks.map(CardFooterLink)}</Styled.CardFooter>
    </DefaultCard>
  );
};

export default BlogPostCard;
